export function createUnsubscribeApi(baseUrl) {
  return {
    unsubscribe: `${baseUrl}/v1/notifications/unsubscribe/`,
  };
}
